<template>
    <path d="M2.07 3.05c-.41.16-.96.71-1.13 1.13-.13.23-.16.3-.12 7.81l.03.6c0 6.58 0 6.86.24 7.33.24.46.58.78 1.02.97.44.2.42.23 8.01.17l1.84.01c10.16 0 9.57.02 10.13-.28.29-.16.69-.57.84-.86.25-.5.25-.37.25-7.92 0-4.28-.02-7.15-.05-7.32-.11-.7-.57-1.3-1.2-1.6-.5-.2-.2-.16-9.94-.16-9.9 0-9.5-.07-9.92.12zm9.96 1.62c8.74-.03 8.76-.05 8.94.01.2.1.29.2.37.38.08.17.09.53.07 5.97l-.01 5.8-2.25-3.01c-2.58-3.44-2.4-3.25-3.18-3.3-.52-.03-1.03.1-1.29.33-.08.07-.9 1.3-1.82 2.72-2.43 3.76-2.27 3.52-2.48 3.63-.1.05-.29.09-.4.09-.43 0-.54-.1-1.73-1.46-.61-.71-1.2-1.37-1.31-1.47-.59-.56-1.26-.59-1.84-.06-.12.1-.71.81-1.32 1.57l-1.01 1.26-.02-7.29c0-4.98 0-4.96.03-5.03.03-.07.09-.11.17-.13.14-.02.8-.03 9.08-.01zM8.58 6.7A2.51 2.51 0 0 0 6.1 8.38a2.48 2.48 0 0 0 1.87 3.23 2.5 2.5 0 0 0 2.86-1.83 2.5 2.5 0 0 0-2.26-3.07z"/>
</template>

<script>
    export default {
        name: 'gallery',
    }
</script>



// WEBPACK FOOTER //
// src/components/icon/Gallery.vue